import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby-theme-material-ui';
import {
  Box,
  Button,
  Paper,
  Skeleton,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import { getProgramGroups } from '../../../api/strapi';
import { parseDate, preparePrice } from '../../../helpers/lib';

import Section from '../../../shared/Section/Section';
import ClockIcon from '../../../shared/Feature/icons/ClockIcon';
import CalendarIcon from '../../../shared/Feature/icons/CalendarIcon';
import styles from './styles';
import { sendYandexMetrikaEvent } from '../../../helpers/yandexMetrika';
import { sendMyTargetEvent } from '../../../helpers/myTarget';

const PROGRAM = 'JS';

function EducationFormat({ title, list, images }) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [groups, setGroups] = useState(list);

  useEffect(() => {
    const ac = new AbortController();
    getProgramGroups(ac, PROGRAM, null, true).then(
      (groups) =>
        groups &&
        setGroups((prevState) =>
          prevState.reduce((acc, curr) => {
            const dbGroup = groups.find((el) => el.location === curr.location);
            const startDate = parseDate(dbGroup?.startDate);
            const fullFormat = {
              ...curr,
              ...dbGroup,
              startDate: startDate ? `${startDate[1]} ${startDate[2]}` : null,
            };
            return [...acc, fullFormat];
          }, []),
        ),
    );
  }, [list]);

  return (
    <Section title={title} withoutBg>
      <Typography variant="desktopP2" sx={styles.explanation}>
        Программа обучения во всех форматах одинаковая.
      </Typography>
      <Box>
        <Box sx={styles.formatsContainer}>
          {groups.map(
            (
              {
                name,
                location,
                profession,
                duration,
                startDate,
                price,
                href,
                ymEvent,
                myTargetEvent,
              },
              index,
            ) => (
              <Paper key={index} elevation={0} sx={styles.formatItem}>
                <Box sx={styles.container}>
                  <Box sx={styles.imageWrapper}>
                    <GatsbyImage
                      image={getImage(
                        images[`devPage/${location.toLowerCase()}`],
                      )}
                      style={{
                        height: '100%',
                        objectFit: 'cover',
                        width: 'auto',
                      }}
                      alt={name}
                      loading="auto"
                      layout="fullWidth"
                    />
                  </Box>
                  <Box sx={styles.contentContainer}>
                    <Box
                      sx={{
                        display: 'flex',
                      }}
                    >
                      <Typography
                        sx={styles.profession}
                        fontSize={isSm ? 11 : 12}
                        textAlign="left"
                      >
                        {`<${profession}>`}
                      </Typography>
                      <Box sx={styles.duration}>
                        <CalendarIcon fillColor="#4520AB" />
                        <Typography variant="desktopP2">{duration}</Typography>
                      </Box>
                    </Box>
                    <Typography
                      variant={isSm ? 'mobileH4' : 'desktopH4'}
                      fontWeight={700}
                      mt={4}
                    >
                      {name}
                    </Typography>
                    <Box sx={styles.startDate}>
                      <ClockIcon strokeColor="#4520AB" />
                      {
                        <Typography
                          variant={isSm ? 'mobileP3' : 'desktopP2'}
                          component={'div'}
                          display={'flex'}
                          gap={1}
                          alignItems={'center'}
                        >
                          старт:{' '}
                          {startDate || (
                            <Skeleton
                              height={25}
                              width={80}
                              sx={{ backgroundColor: '#ffffff80' }}
                            />
                          )}
                        </Typography>
                      }
                    </Box>
                    <Box sx={{ mt: 'auto', display: 'flex' }}>
                      <Box>
                        <Typography variant="desktopP1">
                          {price ? (
                            `От ${preparePrice(price.bankLoanPricePerMonth)}
                        ₽/месяц`
                          ) : (
                            <Skeleton
                              width={120}
                              height={40}
                              sx={{ backgroundColor: '#ffffff80' }}
                            />
                          )}
                        </Typography>
                        <Typography
                          variant={isSm ? 'mobileP3' : 'desktopP3'}
                          color="#FFFFFFB2"
                        >
                          {price ? (
                            `или сразу ${preparePrice(price.fullPrice)}₽`
                          ) : (
                            <Skeleton
                              width={120}
                              height={20}
                              sx={{ backgroundColor: '#ffffff80' }}
                            />
                          )}
                        </Typography>
                      </Box>
                      <Box sx={{ ml: 'auto' }}>
                        <Link underline="none" href={href}>
                          <Button
                            variant="kitPrimary"
                            size={isSm ? 'small' : 'medium'}
                            onClick={() => {
                              sendYandexMetrikaEvent(ymEvent);
                              sendMyTargetEvent(myTargetEvent);
                            }}
                          >
                            подробнее
                          </Button>
                        </Link>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            ),
          )}
        </Box>
      </Box>
    </Section>
  );
}

export default EducationFormat;
